import { Component } from '@angular/core';
import { BaseComponent } from '../shared/base-components/base.component';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CustomerPurgeService } from './customer-purge.service';
import { MvdModalService } from 'app/shared/services/modal/mvd-modal.service';
import { filter } from 'rxjs/operators';
import { CustomerManageService } from 'app/customer/shared/customer-manage.service';

@Component({
    selector: 'delete-customer-identification-modal',
    templateUrl: './delete-customer-identification.modal.html'
})

export class DeleteCustomerIdentificationWindow extends BaseComponent {

    // Gets or sets the isDabled flag
    public isDisable = true;

    // Gets or sets the showMessage
    public showMessage = false;

    // Gets or sets the customer number id
    public customerNumberId: number;

    // Gets or sets the showSuccsessMessage
    public showSuccessMessage = false;

    // Gets or sets the ssn Table.
    public showSSNTable = false;

    // Gets customer SSN
    public customerSSN: string;

    /**
     * Constructor injections.
     * @param dialogRef - dialog ref
     * @param customerPurgeService - customer purge service for delte call
     * @param modalService - Modal service for alert
     */
    constructor(public dialogRef: MatDialogRef<DeleteCustomerIdentificationWindow>
        , public customerPurgeService: CustomerPurgeService
        , public modalService: MvdModalService
        , public customerManageService: CustomerManageService) {
        super();
    }

    ngOnInit() {

    }

    /**
     * Customer search bar selection.
     * @param event
     */
    customerSelected(event) {
        this.isDisable = false;
        this.customerNumberId = event.customerNumber;

        // Gets the customer SSN
        this.customerManageService.getCustomerIdentifications(event.customerNumber).subscribe(
            r => {
                let customerIdentification = r.filter(x => x.customerIdentificationTypeId === 5);
                this.customerSSN = customerIdentification[0].customerIdentificationValue;
                this.showSSNTable = true;
            },
            e => {
                console.log(e);
            }
        );
    }

    /**
     * Delete the identification
     * */
    deleteIdentification() {

        this.modalService.alert().title('Confirm').body('Are you sure you want to delete the customer\'s SSN').open().afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.confirmDelete());
    }

    /**
     * Confirm delete to delete the SSN
     * */
    private confirmDelete() {
        this.customerPurgeService.deleteCustomerIdentification(this.customerNumberId).subscribe(
            res => {
                if (res.result) {
                    this.showSuccessMessage = true;
                    this.isDisable = true;
                }
            }
        );
    }

    /**
     * Close the modal.
     * */
    public cancel() {
        this.dialogRef.close();
    }

}
